import { Form, Input, Select } from 'antd';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Button from '../../../components/uielements/button';
import IntlMessages from '../../../components/utility/intlMessages';
import Modals from '../../../components/feedback/modal';
import WithDirection from '../../../settings/withDirection';
import ModalStyle from '../../DefaultStyle/modal.style';
import CreateShopRemarkTypeModal from './createShopRemarkTypeModal';
import { apiErrorHandler } from '../../../helpers/errorHelper';
import { getAllShopRemarkType, getShopRemarkList } from '../../../redux/request/actions';
import { toggleCreateShopRemarkModal, toggleCreateShopRemarkTypeModal } from '../../../redux/ui/actions';
import { postCreateShopRemark } from '../../../redux/request/apis';
import permission from '../../../settings/permission';

const isoModal = ModalStyle(Modals);
const Modal = WithDirection(isoModal);
const FormItem = Form.Item;

class CreateShopRemarkModal extends Component {
  state = {
    submitLoading: false,
  };

  componentDidMount() {
    const { getAllShopRemarkType, shopRemarkTypesFetched } = this.props;
    if (!shopRemarkTypesFetched) {
      getAllShopRemarkType({});
    }
    this.initValue(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.initRemark !== nextProps.initRemark) {
      this.initValue(nextProps);
    }
  }

  initValue = (props) => {
    this.props.form.setFieldsValue({
      remark: props.initRemark,
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.createShopRemarkType(values);
      }
    });
  };

  createShopRemarkType = async (values) => {
    this.setState({ submitLoading: true });
    const {
      intl, toggleCreateShopRemarkModal, onSuccess, shopId, action,
    } = this.props;
    const data = {
      shopId,
      ...values,
      enabled: true,
    };
    try {
      await postCreateShopRemark({ data });
      this.setState({
        submitLoading: false,
      });
      this.props.form.resetFields();
      toggleCreateShopRemarkModal({
        open: false, shopId: undefined, initRemark: undefined, canClose: false,
      });
      if (onSuccess) {
        onSuccess();
      }
      if (action) {
        action();
      }
    } catch (error) {
      apiErrorHandler(error, intl);
      this.setState({
        submitLoading: false,
      });
    }
  };

  handleCreateShopRemarkTypeSuccess = (shopRemarkTypeId) => {
    const { getAllShopRemarkType } = this.props;
    getAllShopRemarkType();
    this.props.form.setFieldsValue({
      shopRemarkTypeId,
    });
  }

  render() {
    const {
      authority, intl, toggleCreateShopRemarkModal, toggleCreateShopRemarkTypeModal, open, shopRemarkTypes, canClose,
    } = this.props;
    const { submitLoading } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
    };
    let locale = 'en';
    if (intl.locale === 'en-US') {
      locale = 'en';
    } else if (intl.locale === 'zh-Hans-HK') {
      locale = 'zh_hk';
    } else if (intl.locale === 'zh-Hans-CN') {
      locale = 'zh_cn';
    }

    let nameKey = 'name_en';
    if (intl.locale === 'en-US') {
      nameKey = 'name_en';
    } else if (intl.locale === 'zh-Hans-HK') {
      nameKey = 'name_tc';
    } else if (intl.locale === 'zh-Hans-CN') {
      nameKey = 'name_sc';
    }

    let createShopRemarkTypeButton = null;
    if (permission.MEMBER.ADD_REMARK_TYPE.some(s => authority.includes(s))) {
      createShopRemarkTypeButton = (
        <div style={{ marginTop: '5px' }}>
          <Button
            className="add-type-btn"
            icon="plus"
            onClick={() => toggleCreateShopRemarkTypeModal({ open: true })}
          >
            <IntlMessages id="member.userRemark.newRemarkType" />
          </Button>
        </div>
      );
    }

    return (
      <Modal
        visible={open}
        closable={canClose}
        onCancel={canClose ? () => toggleCreateShopRemarkModal({
          open: false, shopId: undefined, initRemark: undefined, canClose: false,
        }) : null}
        title={<IntlMessages id="member.userRemark.addRemark" />}
        footer={null}
      >
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label={<IntlMessages id="member.userRemark.type" />}
          >
            {getFieldDecorator('shopRemarkTypeId', {
              rules: [
                {
                  required: true,
                },
              ],
            })(
              <Select>
                {shopRemarkTypes.map(type => (
                  <Select.Option value={type.id} key={type.id}>
                    {type[nameKey]}
                  </Select.Option>
                ))}
              </Select>,
            )}
            {createShopRemarkTypeButton}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label={<IntlMessages id="member.userRemark.remark" />}
          >
            {getFieldDecorator('remark', {
              rules: [
                {
                  required: true,
                },
              ],
            })(<Input.TextArea />)}
          </FormItem>
          <FormItem wrapperCol={{ span: 12, offset: 8 }}>
            <Button
              className="sino-btn"
              htmlType="submit"
              loading={submitLoading}
            >
              <IntlMessages id="common.submit" />
            </Button>
          </FormItem>
        </Form>
        <CreateShopRemarkTypeModal onSuccess={this.handleCreateShopRemarkTypeSuccess} />
      </Modal>
    );
  }
}

const WrappedFormWIthSubmissionButton = Form.create()(
  CreateShopRemarkModal,
);

export default injectIntl(connect(
  state => ({
    authority: state.getMyAuthority.data,
    open: state.toggleCreateShopRemarkModal.open,
    shopId: state.toggleCreateShopRemarkModal.shopId,
    action: state.toggleCreateShopRemarkModal.action,
    canClose: state.toggleCreateShopRemarkModal.canClose,
    initRemark: state.toggleCreateShopRemarkModal.initRemark,
    shopRemarkTypes: state.getAllShopRemarkType.data,
    shopRemarkTypesFetched: state.getAllShopRemarkType.dataFetched,
  }),
  {
    toggleCreateShopRemarkModal,
    toggleCreateShopRemarkTypeModal,
    getAllShopRemarkType,
    getShopRemarkList,
  },
)(WrappedFormWIthSubmissionButton));
